import styled from "vue-styled-components";

export const StyleButton = styled.button`
    /* background-color: ${props => props.theme?.products?.button?.background_color ?? "#ffffff"};
    color: ${props => props.theme?.products?.button?.color ?? props.theme.primary_color ?? "#000000"};
    border: 1px solid ${props => props.theme?.products?.button?.border_color ?? props.theme.primary_color ?? "#000000"}; */
    border-radius: ${props => props.theme?.products?.button?.border_radius ?? "0"};
    text-transform: ${props => props.theme?.products?.button?.text_transform ?? "uppercase"};

    font-size: ${props => props.theme.font_size_button ?? "1.4rem"};
    font-weight: 400;
    font-family: ${props => props.theme?.products?.button?.font_family ?? props.theme?.footer?.font_family_title ?? props.theme?.font_family ?? "Open Sans"}, sans-serif;

    cursor: pointer;
    padding: 0.3rem 2rem;
    line-height: 1.5;
    letter-spacing: unset;
    transition: 0.2s;
    min-height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;

    /* &:hover,
    &:focus {
        color: ${props => props.theme?.products?.button?.color_hover ?? "#ffffff"};
        border-color: ${props => props.theme?.products?.button?.border_color_hover ?? props.theme.hover ?? "#000000"};
        background-color: ${props => props.theme?.products?.button?.background_color_hover ?? props.theme.hover ?? "#000000"};
    } */
`;

export const StyleInputGroup = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;

    label {
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        margin: 0;
        font-weight: 600;
        font-size: 1.35rem;
    }

    input, select, textarea {
        background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'} !important;
        border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
        border-radius: ${props => props.theme?.inputs?.border_radius ?? '0'};
        color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        outline: none;
        padding: 0.7rem 1rem;

        &::placeholder {
            color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        }

        &:focus {
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
        }
    }
`;

export const PrimaryButton = styled(StyleButton)`
    background-color: ${props => props.theme?.products?.button?.background_color ?? "#ffffff"};
    color: ${props => props.theme?.products?.button?.color ?? props.theme.primary_color ?? "#000000"};
    border: 1px solid ${props => props.theme?.products?.button?.border_color ?? props.theme.primary_color ?? "#000000"};

    &:hover,
    &:focus {
        color: ${props => props.theme?.products?.button?.color_hover ?? "#ffffff"};
        border-color: ${props => props.theme?.products?.button?.border_color_hover ?? props.theme.hover ?? "#000000"};
        background-color: ${props => props.theme?.products?.button?.background_color_hover ?? props.theme.hover ?? "#000000"};
    }
`;

export const CancelButton = styled(StyleButton)`
    background-color: ${props => props.theme?.button_cancel?.background_color ?? "#f8f9fa"};
    color: ${props => props.theme?.button_cancel?.color ?? "#212529"};
    border: 1px solid ${props => props.theme?.button_cancel?.border_color ?? "#f8f9fa"};

    &:hover,
    &:focus {
        color: ${props => props.theme?.button_cancel?.color_hover ?? "#212529"};
        border-color: ${props => props.theme?.button_cancel?.border_color_hover ?? "#dae0e5"};
        background-color: ${props => props.theme?.button_cancel?.background_color_hover ?? "#e2e6ea"};
    }
`;
